import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateVoteHeadForm from "../../forms/CreateOrUpdateVoteHeadForm";
import { VoteHeadResponseDto } from "../../shared/dtos/voteHead/VoteHeadResponseDto";

interface UpdateVoteHeadModalProps {
  open: boolean;
  onClose: () => void;
  voteHead: VoteHeadResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateVoteHeadModal: React.FC<UpdateVoteHeadModalProps> = ({
  open,
  onClose,
  voteHead,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${voteHead.name}`}
    width="sm"
    loading={loading}
  >
    <CreateOrUpdateVoteHeadForm
      isEditing={true}
      voteHead={voteHead}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateVoteHeadModal;
